interface IUserSettings {
  readonly Timezone: string;
}

export interface IAPIUserInfo {
  readonly UserName: string;
  readonly UserID: string;
  readonly UserType: number;
  readonly Address: string;
  readonly Avatar: string;
  readonly CellPhone: string;
  readonly City: string;
  readonly Company: string;
  readonly CreateTime: Date;
  readonly Email: string;
  readonly GCloudID: string;
  readonly ModifyTime: Date;
  readonly id: number;
  readonly _id: string;
  readonly UserSettings?: IUserSettings;
}

export enum UserType {
  GCloud = 2,
  Gos = 1,
  IOA = 3,
  Email = 4,
}

export interface ICreateAccount {
  readonly email: string;
  readonly password: string;
  readonly validateRef: string;
  readonly userType: UserType | undefined;
  readonly ticket: string;
  readonly randstr: string;
}

export interface IAccessToken {
  readonly token: string;
  readonly expired: number;
  readonly time: number;
  readonly version?: string;
}
